import { createSelector } from '@reduxjs/toolkit';
import translate from '../utilities/translator';
import format from '../utilities/format';
import { parseDate } from '../utilities/helpers';
import { selectFilterData } from '../features/mainFilter/selectors';

export const mobileSearchLabelSelector = createSelector(
  [selectFilterData],
  (mainFilter) => {
    if (mainFilter.pending || mainFilter.error) return '';

    const { what, where, when, who } = mainFilter.searchEngine;

    const labelsArray = [];
    const whatValues = what.filter((item) => item.active);
    const whereValues = where.destinations.filter((item) => item.active);

    if (whatValues.length === 0)
      labelsArray.push(translate('holidayFinder.mainFilter.all_types'));
    if (whatValues.length === 1) labelsArray.push(`${whatValues[0].value}`);
    if (whatValues.length > 1)
      labelsArray.push(`${whatValues[0].value} + ${whatValues.length - 1}`);

    if (whereValues.length === 0)
      labelsArray.push(translate('holidayFinder.mainFilter.everywhere'));
    if (whereValues.length === 1) labelsArray.push(`${whereValues[0].name}`);
    if (whereValues.length > 1)
      labelsArray.push(`${whereValues[0].name} + ${whereValues.length - 1}`);

    if (when.months?.length === 0 && !when.startDate)
      labelsArray.push(translate('holidayFinder.mainFilter.any_dates'));
    if (when.type === 'month' && when.months?.length > 0) {
      labelsArray.push(
        when.months.map((m) => format(parseDate(m, 'M'), 'MMM')).join(', ')
      );
    }
    if (when.type === "specific" || when.type === "range") {
      const startDate = when.startDate ? format(parseDate(when.startDate), "dd MMM") : translate('holidayFinder.mainFilter.any');
      const endDate = when.endDate ? format(parseDate(when.endDate), "dd MMM") : translate('holidayFinder.mainFilter.any');
      labelsArray.push(`${startDate} - ${endDate}`);
    }

    const babies = who.childAges.reduce((b, current) => { if (current < 2) { return (b + 1); } return b; }, 0);

    labelsArray.push(
      `${who.adults} ${translate('holidayFinder.general.adults_plural', {
        count: who.adults,
      })} ${
        (who.children - babies) > 0
          ? ` & ` +
          `${who.children - babies}
            ${translate('holidayFinder.general.children_plural', {
            count: (who.children - babies),
          })}`
          : ''
      } ${
        babies > 0
          ? ` & ` +
          `${babies}
            ${translate('holidayFinder.general.infants_plural', {
            count: babies,
          })}`
          : ''
      } ${
        who.rooms > 1
          ? ` & ${who.rooms} ${translate('holidayFinder.general.rooms_plural', {
            count: who.rooms,
          })} `
          : ''
      }`
    );

    return labelsArray.join(', ');
  }
)
